import { useState } from 'react';
import { canWrite } from 'documents-ui/lib/permissions';
import { useDocumentDescription } from './hooks/useDocumentDescription';
import DescriptionAIDisclaimer from './DescriptionAIDisclaimer';
import DocumentDescriptionModal from './DocumentDescriptionModal';
import styled from 'styled-components';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DescriptionContainer = styled.div.withConfig({
  displayName: "DocumentDescription__DescriptionContainer"
})(["position:relative;width:fit-content;"]);
const EditDescriptionButtonContainer = styled.div.withConfig({
  displayName: "DocumentDescription__EditDescriptionButtonContainer"
})(["position:absolute;right:0;"]);
export const DocumentDescription = ({
  deckId
}) => {
  const [showDocumentDescriptionModal, setShowDocumentDescriptionModal] = useState(false);
  const {
    correlationId,
    description,
    feedbackDisabled,
    isLoading,
    isUserEdited,
    saveDescription,
    generateDescription,
    submitDescriptionFeedback,
    setFeedbackDisabled
  } = useDocumentDescription({
    deckId
  });
  if (isLoading && !showDocumentDescriptionModal) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(AISkeleton, {
        width: "75%"
      }), /*#__PURE__*/_jsx(AISkeleton, {
        width: "65%"
      })]
    });
  }
  const handleCloseModal = () => {
    setShowDocumentDescriptionModal(false);
    setFeedbackDisabled(true);
  };
  const renderEmptyState = () => {
    return canWrite() ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.description.missing"
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "add-description-button",
        use: "link",
        onClick: () => setShowDocumentDescriptionModal(true),
        marginInlineStart: "100",
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.description.add"
        })
      }), /*#__PURE__*/_jsx(BreezeSingleStarIcon, {
        size: "300",
        color: "do-not-use-obsidian"
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.description.emptyState.description"
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "300",
    as: "div",
    children: [!description && renderEmptyState(), description && /*#__PURE__*/_jsxs(DescriptionContainer, {
      children: [canWrite() && /*#__PURE__*/_jsx(EditDescriptionButtonContainer, {
        children: /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": "edit-description-button",
          use: "link",
          size: "extra-small",
          onClick: () => setShowDocumentDescriptionModal(true),
          children: /*#__PURE__*/_jsx(EditIcon, {
            size: "200"
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        "data-test-id": "document-description-text",
        marginBlockEnd: "200",
        paddingInlineEnd: "600",
        as: "div",
        children: description
      }), /*#__PURE__*/_jsx(DescriptionAIDisclaimer, {
        isUserEdited: isUserEdited
      })]
    }), showDocumentDescriptionModal && /*#__PURE__*/_jsx(DocumentDescriptionModal, {
      correlationId: correlationId,
      description: description,
      feedbackDisabled: feedbackDisabled,
      isLoading: isLoading,
      isUserEdited: isUserEdited,
      closeModal: handleCloseModal,
      generateDescription: generateDescription,
      saveDescription: saveDescription,
      submitDescriptionFeedback: submitDescriptionFeedback
    })]
  });
};